export const unsafeEntries = Object.entries;
export const unsafeKeys = Object.keys;
export function assert(value, message) {
    if (!value) {
        throw new Error(message);
    }
}
export function isString(a) {
    return typeof a === "string";
}
export function isStringArray(a) {
    return a.every(isString);
}
export function isNumber(a) {
    return typeof a === "number";
}
export function isNumberArray(a) {
    return a.every(isNumber);
}
export const unsafeToLowerCase = (s) => s.toLowerCase();
export const unsafeReplace = (t, s, r) => t.replaceAll(s, r);
export function hasExactly(array, length) {
    return array.length === length;
}
export function hasAtLeast(array, length) {
    return array.length >= length;
}
export const mod = (n, m) => ((n % m) + m) % m;
/**
 *
 * @param date optional date to use, otherwise a new Date object is created and the current time will be returned
 */
export function getUtcMinutesAfterMidnight(date) {
    const _date = date ?? new Date();
    return _date.getUTCHours() * 60 + _date.getUTCMinutes();
}
export function formatUtcTime(_date, withSeconds = false) {
    const date = !(_date instanceof Date) ? new Date(_date) : _date;
    let ret = `${date.getUTCHours().toString().padStart(2, "0")}${date.getUTCMinutes().toString().padStart(2, "0")}`;
    if (withSeconds) {
        ret += ":" + date.getUTCSeconds().toString().padStart(2, "0");
    }
    return ret;
}
export function removeUndefined(obj, removeNull = false) {
    return Object.fromEntries(Object.entries(obj).filter(([, value]) => value !== undefined && (!removeNull || value !== null)));
}
export function sumBy(array, getNumber) {
    return array.reduce((a, b) => a + getNumber(b), 0);
}
export function isCoordinate(a) {
    return Array.isArray(a) && a.length === 2 && a.every((e) => typeof e === "number");
}
export function typedSplitString(s, sep) {
    return s.split(sep);
}
export function formatAdsbAddress(address) {
    return address.toString(16).padStart(6, "0").toLowerCase();
}
//# sourceMappingURL=utility-functions.js.map